import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";
import { RiLockPasswordLine } from "react-icons/ri";
import { getItemToken } from "../../../Utils/localStorageUtils";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { toast } from "react-toastify";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import { currentIpAddressDetails } from "../../../components/CommonMethod/CommonMethods";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { IoMdInformationCircle } from "react-icons/io";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import UserSelector from "./UserSelector";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import moment from "moment";
import { FaEllipsisVertical } from "react-icons/fa6";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { statusActiveFormatteruser } from "../../../components/CommonMethod/CommonBoostrapFormatter";
function EditPartner() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const { id } = useParams();
  const navigate = useNavigate();
  const [countryid, setCountryid] = useState(0);
  const [stateid, setstateid] = useState(0);
  const [cityid, setCityid] = useState(0);
  const [modalCountryid, setModalCountryid] = useState(0);
  const [modalStateid, setModalStateid] = useState(0);
  const [modalCityid, setModalCityid] = useState(0);

  const handleWorld = (name, value) => {
    setEditPartner({ ...editPartner, [name]: value });
  };

  // Refs for form fields
  const usernameRef = useRef(null);
  const lastnameRef = useRef(null);
  const emailRef = useRef(null);
  const profileRef = useRef(null);
  const mobileRef = useRef(null);
  const codeRef = useRef(null);
  const roleRef = useRef(null);
  const commissionRef = useRef(null);
  const bankNameRef = useRef(null);
  const branchNameRef = useRef(null);
  const accountNumberRef = useRef(null);
  const ifscCodeRef = useRef(null);
  const passwordRef = useRef(null);


  const userAccessToken = getItemToken("access_token");
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [profileImageFile, setProfileImageFile] = useState("");
  const [thumbnailImageFile, setThumbnailImageFile] = useState("");
  const [editUserId, setEditUserId] = useState(null);
  const [editPartnerError, setEditPartnerError] = useState({});
  const [showOverlay, setShowOverlay] = useState(false);
  const [domReload, setDomReload] = useState(false);
  const [defaultData, setDefaultData] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [editPartner, setEditPartner] = useState({
    username: "",
    last_name: "",
    email: "",
    mobile_number: "",
    avatar: "",
    ccode: "",
    ccode_unique: "",
    city: "",
    state: "",
    country: "",
    gender: "",
    commission_percentage: "",
    bank_name: "",
    branch_name: "",
    account_number: "",
    IFSC_Code: "",
    upi_id: "",
    upi_mobile_number: "",
    role_id: "",
    status: 1,
    password: "",
  });

  const [childPage, setChildPage] = useState(1);
  const [childLimit, setChildLimit] = useState(5);

  const [passwordType, setPasswordType] = useState("password");
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };


  const [customFieldValues, setCustomFieldValues] = useState({})
  const [selectedUsers, setSelectedUsers] = useState([]); // For assign partner functionality
  const [showUserModal, setShowUserModal] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [modalAvatarFile, setModalAvatarFile] = useState(null);
  const [modalThumbnailFile, setModalThumbnailFile] = useState(null);
  const [editUserLoading, setEditUserLoading] = useState(false);
  const access_token = localStorage.getItem("access_token");
  const headers = {
    Authorization: "Bearer " + access_token,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;

    if (type === "checkbox") {
      setEditPartner((prevEditPartner) => ({
        ...prevEditPartner,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === "text" || type == "number" || type == "email") {
      if ((name === "username" || name === "last_name") && /\d/.test(value)) {
        return;
      }
      setEditPartner((prevEditPartner) => ({
        ...prevEditPartner,
        [name]: value || "",
      }));
    }
    if (type === "select-one") {
      setEditPartner((prev) => ({
        ...prev,
        [name]: value,
      }));
      setEditPartnerError((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    if (type === "password" || (name === "password" && type === "text")) {
      setEditPartner((prev) => ({
        ...prev,
        [name]: value,
      }));
      setIsPasswordChanged(true);
    }

    setEditPartnerError((prevEditPartnerError) => ({
      ...prevEditPartnerError,
      [name]: "",
    }));
  };


  // Fetch partner creation data
  const fetchData = async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/partner/create`, {
        headers: userAccessToken,
      })
      .then((response) => {
        setDefaultData((prev) => ({
          ...prev,
          partnerRoles: response?.data?.partnerRoles,
          country: response?.data?.country,
          partnersignupmenu: response?.data?.partnersignupmenu,
        }));
      })
      .catch((error) => toast.error(error?.response?.data?.message));
  };

  // Get partner data for editing
  const getPartner = async () => {
    setShowOverlay(true);
    try {
      const reqData = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/partner/edit/${id}`,
        { headers: userAccessToken }
      );
      if (reqData?.data?.status) {
        const partnerData = reqData?.data?.data?.partnerUser;
        setShowOverlay(false);
        setEditPartner({
          username: partnerData?.username || "",
          last_name: partnerData?.last_name || "",
          email: partnerData?.email || "",
          mobile_number: partnerData?.mobile || "",
          avatar: partnerData?.avatar || "",
          ccode: partnerData?.ccode || "",
          ccode_unique: "",
          city: partnerData?.city || "",
          state: partnerData?.state || "",
          country: partnerData?.country || "",
          gender: partnerData?.gender || "",
          commission_percentage: partnerData?.commission_percentage || "",
          bank_name: partnerData?.bank_name || "",
          branch_name: partnerData?.branch_name || "",
          account_number: partnerData?.account_number || "",
          IFSC_Code: partnerData?.IFSC_Code || "",
          upi_id: partnerData?.upi_id || "",
          upi_mobile_number: partnerData?.upi_mobile_number || "",
          role_id: partnerData?.user_role || "",
          status: partnerData?.status || 1,
          thumbnail_image: partnerData?.thumbnail_image_url || "",
        });
        // combinedData merges user over partner, so id resolves to user id
        if (reqData?.data?.data?.partnerUser?.id) {
          setEditUserId(reqData.data.data.partnerUser.id);
        }

        setDefaultData((prev) => ({
          ...prev,
          partnerRoles: reqData?.data?.data?.roles,
          country: reqData?.data?.data?.countryCodes,
          partnersignupmenu: reqData?.data?.data?.signupConfig,
        }));

        // Load existing assigned users if available
        if (reqData?.data?.data?.assignedPartners) {
          setSelectedUsers(reqData.data.data.assignedPartners);
        }
      }
    } catch (error) {
      setShowOverlay(false);
      toast.error(error?.response?.data?.message || "Failed to fetch partner data");
    }
  };

  // Handle image upload
  const handleImageChange = async (event) => {
    const { files, name } = event.target;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    setEditPartnerError((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (!files?.[0]) return;
    const selected = files[0];
    if (!allowedTypes.includes(selected.type)) {
      setEditPartnerError((prev) => ({
        ...prev,
        [name]: "Only JPG, JPEG, and PNG files are allowed.",
      }));
      if (name === "image") setProfileImageFile(null);
      if (name === "thumbnail") setThumbnailImageFile(null);
      return;
    }
    if (files?.length > 0) {
      const newFile = files[0];
      if (name === "image") setProfileImageFile(newFile);
      if (name === "thumbnail") setThumbnailImageFile(newFile);
    }
  };

  // Form validation
  const formValidation = () => {
    let formIsValid = true;
    const nameRegex = /^[A-Za-z\s]+$/;

    if (!editPartner?.username) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        username: "User Name cannot be empty.",
      }));
      usernameRef.current.focus();
      formIsValid = false;
    } else if (/\d/.test(editPartner?.username)) {
      setEditPartnerError((prev) => ({
        ...prev,
        username: "User Name should not contain numbers.",
      }));
      usernameRef.current.focus();
      formIsValid = false;
    } else if (!nameRegex.test(editPartner?.username)) {
      setEditPartnerError((prev) => ({
        ...prev,
        username: "User Name should not contain special characters.",
      }));
      usernameRef.current.focus();
      formIsValid = false;
    }

    if (!editPartner?.last_name) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        last_name: "Last Name cannot be empty.",
      }));
      lastnameRef.current.focus();
      formIsValid = false;
    } else if (/\d/.test(editPartner?.last_name)) {
      setEditPartnerError((prev) => ({
        ...prev,
        last_name: "Last Name should not contain numbers.",
      }));
      lastnameRef.current.focus();
      formIsValid = false;
    } else if (!nameRegex.test(editPartner?.last_name)) {
      setEditPartnerError((prev) => ({
        ...prev,
        last_name: "Last Name should not contain special characters.",
      }));
      lastnameRef.current.focus();
      formIsValid = false;
    }

    const normalizedEmail = editPartner.email?.toLowerCase().trim();
    if (!normalizedEmail) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        email: "Email cannot be empty",
      }));
      emailRef.current.focus();
      formIsValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(normalizedEmail)
    ) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        email: "Invalid email address",
      }));
      emailRef.current.focus();
      formIsValid = false;
    } else {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        email: "",
      }));
      setEditPartner((prevPartner) => ({
        ...prevPartner,
        email: normalizedEmail,
      }));
    }

    if (!editPartner?.ccode) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        ccode: "Code cannot be empty.",
      }));
      codeRef.current.focus();
      formIsValid = false;
    }

    if (!editPartner?.mobile_number) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        mobile_number: "Mobile Number cannot be empty.",
      }));
      mobileRef.current.focus();
      formIsValid = false;
    } else if (editPartner?.mobile_number?.length < 7) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        mobile_number: "Mobile Number atleast contain 7 digits.",
      }));
      mobileRef.current.focus();
      formIsValid = false;
    } else if (editPartner?.mobile_number?.length > 15) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        mobile_number: "Mobile number cannot be more than 15 digits.",
      }));
      mobileRef.current.focus();
      formIsValid = false;
    }



    if (!editPartner?.role_id) {
      setEditPartnerError((prevFormData) => ({
        ...prevFormData,
        role_id: "Role cannot be empty.",
      }));
      roleRef.current.focus();
      formIsValid = false;
    }

    if (isPasswordChanged && editPartner?.password) {
      if (editPartner.password.length < 6) {
        setEditPartnerError((prev) => ({
          ...prev,
          password: "Password must be at least 6 characters long.",
        }));
        passwordRef.current.focus();
        formIsValid = false;
      }
    }

    return formIsValid;
  };


  // Handle image upload via admin global image upload API
  const handleImageUpload = async (userId, partnerId) => {
    if (profileImageFile && userId) {
      try {
        const fd = new FormData();
        fd.append('id', String(userId));
        fd.append('modelName', 'User');
        fd.append('avatar', profileImageFile);
        fd.append('imageFields[]', 'avatar');

        await fetchRequest({
          method: 'POST',
          url: globalImageUplaodAPI(),
          params: {},
          data: fd,
        })
      } catch (err) {
        console.error('Profile image upload failed', err);
      }
    }

    if (thumbnailImageFile && partnerId) {
      try {
        const fd = new FormData();
        fd.append('id', String(partnerId));
        fd.append('modelName', 'Partner');
        fd.append('thumbnail_image', thumbnailImageFile);
        fd.append('imageFields[]', 'thumbnail_image');

        await fetchRequest({
          method: 'POST',
          url: globalImageUplaodAPI(),
          params: {},
          data: fd,
        })
      } catch (err) {
        console.error('Thumbnail image upload failed', err);
      }
    }
  };

  // Handle update
  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formData = {
        username: editPartner?.username,
        last_name: editPartner?.last_name,
        email: editPartner?.email,
        ccode: `${editPartner?.ccode}`,
        mobile_number: editPartner?.mobile_number,
        city: editPartner?.city,
        state: editPartner?.state,
        country: editPartner?.country,
        gender: editPartner?.gender,
        commission_percentage: editPartner?.commission_percentage,
        bank_name: editPartner?.bank_name,
        branch_name: editPartner?.branch_name,
        account_number: editPartner?.account_number,
        IFSC_Code: editPartner?.IFSC_Code,
        upi_id: editPartner?.upi_id,
        upi_mobile_number: editPartner?.upi_mobile_number,
        role_id: editPartner?.role_id,
        status: editPartner?.status,
        assigned_users: (selectedUsers || []).map(user => ({
          user_id: user.id || user.user_id,
          change_role_to: 4 // Change user role to 4 (Partner)
        })), // Add selected users for partner assignment
      };

      if (isPasswordChanged && editPartner?.password) {
        formData.password = editPartner.password;
      }


      // Log the users being assigned for debugging
      if (selectedUsers.length > 0) {
        console.log('Assigning users to partner:', selectedUsers.map(u => ({
          id: u.id,
          username: u.username || u.email
        })));
      }

      await axios
        .post(
          `${process.env.REACT_APP_Baseurl}/admin/partner/update/${id}`,
          formData,
          {
            headers: userAccessToken,
          }
        )
        .then(async (res) => {
          if (res?.data?.status) {
            // save custom field values (strict)
            try {
              const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
              const cfRes = await saveCustomFieldsConditional(
                process.env.REACT_APP_Baseurl,
                userAccessToken,
                'partner',
                id,
                customFieldValues
              );
              if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
            } catch (e) {
              toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
              setShowOverlay(false);
              return;
            }
            // try {
            //   const cfRes = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/custom-field-values`, { entity_type: 'partner', entity_id: id, values: {} }, { headers: userAccessToken });
            //   if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
            // } catch (e) {
            //   toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
            //   setShowOverlay(false);
            //   return;
            // }
            if (id && (profileImageFile || thumbnailImageFile)) {
              await handleImageUpload(editUserId, id);
            }

            // Show success message with assignment info
            let successMessage = res?.data?.message;
            if (selectedUsers.length > 0) {
              successMessage += ` ${selectedUsers.length} user(s) assigned as partner(s).`;
            }
            toast.success(successMessage);

            setShowOverlay(false);
            setDomReload(!domReload);
            setProfileImageFile(null);
            setEditPartnerError({});
            navigate("/all-partner");
          } else {
            toast.error(res?.data?.message);
            setShowOverlay(false);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong!");
          setShowOverlay(false);
        });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong!");
      setShowOverlay(false);
    }
  };

  const handleEditUser = (user) => {
    setUserToEdit({
      ...user,
      password: "", // Always reset password field for security
      mobile_number: user.mobile || user.mobile_number || "",
      role_id: user.user_role || user.role_id,
      bank_name: user.bank_name || "",
      branch_name: user.branch_name || "",
      account_number: user.account_number || "",
      IFSC_Code: user.IFSC_Code || "",
      upi_id: user.upi_id || "",
      upi_mobile_number: user.upi_mobile_number || "",
      commission_percentage: user.commission_percentage || 0,
      gender: user.gender || "",
      last_name: user.last_name || "",
      ccode: user.ccode || "",
      country: user.country || "",
      state: user.state || "",
      city: user.city || "",
      avatar: user.avatar || "",
      thumbnail_image: user.thumbnail_image_url || user.thumbnail_image || ""
    });

    setModalAvatarFile(null);
    setModalThumbnailFile(null);
    // Reset modal region IDs
    setModalCountryid(0);
    setModalStateid(0);
    setModalCityid(0);

    setShowUserModal(true);
  };

  const handleSaveUser = async () => {
    if (!userToEdit.email || !userToEdit.username) {
      toast.error("Email and Username are required");
      return;
    }

    setEditUserLoading(true);
    try {
      const payload = {
        ...userToEdit,
        status: Number(userToEdit.status),
        mobile_number: userToEdit.mobile_number || userToEdit.mobile,
        uploaded_by: id // Keep track of parent
      };

      const res = await axios.put(
        `${process.env.REACT_APP_Baseurl}/admin/partner/update/${userToEdit.id}`,
        payload,
        { headers }
      );

      if (res.data.status) {
        // Handle child partner image upload
        if (modalAvatarFile || modalThumbnailFile) {
          try {
            const childUserId = userToEdit.id || userToEdit.user_id;
            const childPartnerId = userToEdit.partner_id;

            if (modalAvatarFile && childUserId) {
              const fd = new FormData();
              fd.append('id', String(childUserId));
              fd.append('modelName', 'User');
              fd.append('avatar', modalAvatarFile);
              fd.append('imageFields[]', 'avatar');
              await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), data: fd });
            }

            if (modalThumbnailFile && childPartnerId) {
              const fd = new FormData();
              fd.append('id', String(childPartnerId));
              fd.append('modelName', 'Partner');
              fd.append('thumbnail_image', modalThumbnailFile);
              fd.append('imageFields[]', 'thumbnail_image');
              await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), data: fd });
            }
          } catch (imgErr) {
            console.error('Child partner image upload failed', imgErr);
            toast.warn('Data updated but image upload failed');
          }
        }

        toast.success(res.data.message);
        setShowUserModal(false);
        getPartner(); // Refresh the list
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update partner user");
    } finally {
      setEditUserLoading(false);
    }
  };

  const singleDelete = (childId) => {
    if (window.confirm("Are you sure you want to unassign this partner?")) {
      handleRemoveLocalUser(childId);
      toast.info("Partner unassigned locally. Click 'Update Partner' to save changes.");
    }
  };

  const handleValidate = async (e) => {
    e.preventDefault();
    if (formValidation()) {
      handleUpdate();
    } else {
      console.log("Form validation failed");
    }
  };

  const handleClearSelectFile = (value) => {
    if (value === 'image') setProfileImageFile(null);
    if (value === 'thumbnail') setThumbnailImageFile(null);
    setEditPartnerError((prev) => ({
      ...prev,
      [value === 'image' ? 'avatar' : 'thumbnail']: ""
    }));
  };

  const handleRemoveLocalUser = (userId) => {
    setSelectedUsers(prev => prev.filter(u => u.id !== userId));
  };

  const childColumns = [
    {
      dataField: "username",
      text: "Partners",
      sort: true,
      formatter: (data, row) => (
        <div className="d-flex justify-content-between gap-3 align-items-center">
          {/* <img
            style={{ height: "40px", width: "40px" }}
            src={row.avatar || "/default-avatar.png"}
            alt="Avatar"
            className="userProfileImageSize rounded-circle object-fit-cover"
            onError={(e) => { e.target.src = '/default-avatar.png'; }}
          /> */}
          <div className="rightUserTitle">
            <p className="userNameProfile text-break">{data || row.name || "N/A"}</p>
            {row.createdAt && <span className="userDateText">{moment(row?.createdAt).format('MMMM Do YYYY')}</span>}
          </div>
        </div>
      ),
    },

    {
      dataField: "mobile_number",
      text: "Contact",
      sort: true,
      formatter: (cell, row) => <span className="text-break d-flex align-items-center justify-content-center w-100">{cell || row.mobile || "N/A"}</span>
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "commission_percentage",
      text: "Commission",
      sort: true,
      formatter: (cell) => (
        <div className="d-flex align-items-center justify-content-center w-100">
          <span className="badge bg-info text-dark">{cell || 0}%</span>
        </div>
      )
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => statusActiveFormatteruser(Number(cell) === 1 ? "Active" : "In-Active", row),
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => (
        <div className="editdropdown"
          onClick={() => setActiveId(row.id || row.user_id)}
          onMouseLeave={() => setActiveId(null)}
          id={`moreOption`}>
          <span className="editdropdown-button">
            <FaEllipsisVertical />
          </span>
          <div className={`editdropdown-menu theme-bg-color ${activeId == (row?.id || row?.user_id) ? "d-block" : "d-none"}`} style={{ right: 0, left: 'auto' }}>
            <div id={`Edit`} onClick={() => handleEditUser(row)} className="commonActionPadding theme-text-color theme-bg-color pointer">
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </div>
            <div id={`deleteButton`} onClick={() => row.partner_id ? singleDelete(row.id) : handleRemoveLocalUser(row.id)} className="commonActionPadding theme-bg-color pointer">
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text={row.partner_id ? "Delete" : "Remove"} classname='ms-2 theme-text-color'></MessageBox>
            </div>
          </div>
        </div>
      )
    },
  ];

  useEffect(async () => {
    if (id) {
      await getPartner();
    }
    await fetchData();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "add-partner" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
  }, [domReload]);

  useEffect(() => {
    const fetchCCode = async () => {
      if (!editPartner?.ccode && defaultData?.country) {
        try {
          const res = await currentIpAddressDetails();
          if (res) {
            const matchingCounties = defaultData?.country?.filter(
              (item) => item?.sortname === res?.country_code
            )[0]?.phonecode;

            setEditPartner((prev) => ({
              ...prev,
              ccode: `+${matchingCounties}`,
              ccode_unique: `${res?.country_code},+${matchingCounties}`,
            }));
          } else {
            toast.error('Failed to retrieve IP address details.');
          }
        } catch (error) {
          console.error("Error in fetchCCode:", error);
        }
      }
    };
    fetchCCode();
  }, [editPartner?.ccode, defaultData?.country]);

  useEffect(() => {
    if (editPartner?.ccode && defaultData?.country && !editPartner?.ccode_unique) {
      let match = defaultData.country.find(c => c.id == editPartner.country || c.id == countryid);
      if (!match || `+${match.phonecode}` !== editPartner.ccode) {
         match = defaultData.country.find(c => `+${c.phonecode}` === editPartner.ccode);
      }
      if (match) {
         const phoneCode = `+${match.phonecode}`;
         setEditPartner(prev => ({ ...prev, ccode_unique: `${match.sortname},${phoneCode}` }));
      }
    }
  }, [editPartner?.ccode, defaultData?.country, countryid, editPartner?.country, editPartner?.ccode_unique]);

  const getSelectedPhoneCountry = () => {
    if (editPartner?.ccode_unique?.includes(",")) {
      return editPartner.ccode_unique.split(",")[0]?.toLowerCase();
    }

    if (editPartner?.country && defaultData?.country?.length) {
      const matchedCountry = defaultData.country.find(
        (item) => item?.country_name?.toLowerCase() === editPartner.country?.toLowerCase()
      );
      if (matchedCountry?.sortname) return matchedCountry.sortname.toLowerCase();
    }

    return "in";
  };

  return (
    <>
      {showOverlay && <Response_Processing></Response_Processing>}
      {<AdminBackNavigation path={`${"/all-partner"}`} text="Back" />}
      <AdminSaveHeader
        heading="Edit Partner"
        saveText="Update"
        saveMethod={handleValidate}
        type="submit"
      />
      <form onSubmit={handleValidate}>
        <FormContainer>
          <LeftWrapper>
            <Wrapper>
              <MessageHeading text="Partner Information" />

              <MessageLabel text="Username" className="mandatorySimple" />
              <AdminCustomInput
                type="text"
                id="username"
                name="username"
                value={editPartner?.username}
                placeHolder={"Enter username"}
                ref={usernameRef}
                onChange={handleInput}
                error={editPartnerError?.username}
              />

              <MessageLabel text="Last Name" className="mandatorySimple" />
              <AdminCustomInput
                type="text"
                id="last_name"
                name="last_name"
                value={editPartner?.last_name}
                placeHolder={"Enter last name"}
                ref={lastnameRef}
                onChange={handleInput}
                error={editPartnerError?.last_name}
              />

              <MessageLabel text="Email" className="mandatorySimple" />
              <AdminCustomInput
                type="email"
                id="email"
                name="email"
                value={editPartner?.email}
                placeHolder={"Enter email address"}
                ref={emailRef}
                onChange={handleInput}
                error={editPartnerError?.email}
              />

              <MessageLabel text="Password" />
              <div className="position-relative">
                <AdminCustomInput
                  type={passwordType}
                  id="password"
                  name="password"
                  value={editPartner?.password}
                  placeHolder={"Enter new password (leave blank to keep current)"}
                  ref={passwordRef}
                  onChange={handleInput}
                  error={editPartnerError?.password}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "10px",
                    right: "15px",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                  onClick={togglePassword}
                >
                  {passwordType === "password" ? <TbEyeClosed /> : <VscEye />}
                </div>
              </div>

              <MessageLabel text="Mobile Number" className="mandatorySimple" />
              <div className="mb-3 admin-phone-input-wrapper">
                <PhoneInput
                  country={getSelectedPhoneCountry()}
                  value={`${String(editPartner?.ccode || "").replace("+", "")}${editPartner?.mobile_number || ""}`}
                  onChange={(value, countryData) => {
                    const dialCode = countryData?.dialCode ? `+${countryData.dialCode}` : "";
                    const mobileNumber = dialCode ? value.slice(countryData.dialCode.length) : value;
                    const countryCode = countryData?.countryCode?.toUpperCase() || "";

                    setEditPartner((prev) => ({
                      ...prev,
                      ccode: dialCode,
                      ccode_unique: countryCode ? `${countryCode},${dialCode}` : prev?.ccode_unique,
                      mobile_number: mobileNumber || "",
                    }));

                    setEditPartnerError((prev) => ({
                      ...prev,
                      ccode: "",
                      mobile_number: "",
                    }));
                  }}
                  inputProps={{
                    id: "mobile_number",
                    name: "mobile_number",
                    ref: (input) => {
                      mobileRef.current = input;
                      codeRef.current = input;
                    },
                  }}
                  placeholder="Enter mobile number"
                  countryCodeEditable={false}
                  disableSearchIcon
                  enableSearch
                  inputStyle={{ width: "100%" }}
                  inputClass="bg-transparent theme-text-color rounded-0 ownInputFlag admin-phone-input"
                  dropdownClass="theme-bg-color theme-text-color ownInputDropDown"
                  buttonClass="bg-transparent border-0 p-1 ownButtonClass admin-phone-button"
                />
                {editPartnerError?.mobile_number && (
                  <div className='d-flex align-items-center gap-1 mt-2'>
                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                    <MessageBox text={editPartnerError?.mobile_number} classname='errorred d-block' />
                  </div>
                )}
                {editPartnerError?.ccode && !editPartnerError?.mobile_number && (
                  <div className='d-flex align-items-center gap-1 mt-2'>
                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                    <MessageBox text={editPartnerError?.ccode} classname='errorred d-block' />
                  </div>
                )}
              </div>

              <MessageLabel text="Gender" />
              <AdminCustomSelect
                name="gender"
                value={editPartner?.gender}
                onChange={handleInput}
                options={[
                  { value: "male", name: "Male" },
                  { value: "female", name: "Female" },
                  { value: "other", name: "Other" }
                ]}
                defaultOptionName="Select Gender"
                error={editPartnerError?.gender}
              />

              <MessageLabel text="Commission Percentage" className="mandatorySimple" />
              <AdminCustomInput
                type="number"
                id="commission_percentage"
                name="commission_percentage"
                min={0}
                max={100}
                value={editPartner?.commission_percentage}
                placeHolder={"Enter commission percentage"}
                ref={commissionRef}
                onChange={handleInput}
                error={editPartnerError?.commission_percentage}
              />
            </Wrapper>

            <Wrapper>
              <div className="card p-3 mt-3">
                {/* <MessageHeading text="Additional Fields" /> */}
                {/* Custom fields */}
                <FieldRenderer2
                  pageIdentifier={"site_partner.edit"}
                  entityType={"partner"}
                  entityId={id}
                  text="Additional Fields"
                />
                <FieldRenderer
                  pageIdentifier={"site_partner.edit"}
                  entityType={"partner"}
                  entityId={id}
                  onChange={setCustomFieldValues}
                />
              </div>
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Bank Details" />

              <MessageLabel text="Bank Name" />
              <AdminCustomInput
                type="text"
                id="bank_name"
                name="bank_name"
                value={editPartner?.bank_name}
                placeHolder={"Enter bank name"}
                ref={bankNameRef}
                onChange={handleInput}
                error={editPartnerError?.bank_name}
              />

              <MessageLabel text="Branch Name" />
              <AdminCustomInput
                type="text"
                id="branch_name"
                name="branch_name"
                value={editPartner?.branch_name}
                placeHolder={"Enter branch name"}
                ref={branchNameRef}
                onChange={handleInput}
                error={editPartnerError?.branch_name}
              />

              <MessageLabel text="Account Number" />
              <AdminCustomInput
                type="text"
                id="account_number"
                name="account_number"
                value={editPartner?.account_number}
                placeHolder={"Enter account number"}
                ref={accountNumberRef}
                onChange={handleInput}
                error={editPartnerError?.account_number}
              />

              <MessageLabel text="IFSC Code" />
              <AdminCustomInput
                type="text"
                id="IFSC_Code"
                name="IFSC_Code"
                value={editPartner?.IFSC_Code}
                placeHolder={"Enter IFSC code"}
                ref={ifscCodeRef}
                onChange={handleInput}
                error={editPartnerError?.IFSC_Code}
              />

              <MessageLabel text="UPI ID" />
              <AdminCustomInput
                type="text"
                id="upi_id"
                name="upi_id"
                value={editPartner?.upi_id}
                placeHolder={"Enter UPI ID"}
                onChange={handleInput}
                error={editPartnerError?.upi_id}
              />

              <MessageLabel text="UPI Mobile Number" />
              <AdminCustomInput
                type="number"
                id="upi_mobile_number"
                name="upi_mobile_number"
                value={editPartner?.upi_mobile_number}
                placeHolder={"Enter UPI mobile number"}
                onChange={handleInput}
                error={editPartnerError?.upi_mobile_number}
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Status" />
              <div className="row mx-0">
                <div className="col-9 ps-0">
                  <MessageLabel text="Active Status" />
                </div>
                <div className="col-3 text-end">
                  <label className="switch">
                    <input
                      name="status"
                      onChange={handleInput}
                      checked={Number(editPartner?.status) === 1}
                      type="checkbox"
                      className="rs-input"
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </Wrapper>
          </LeftWrapper>

          <RightWrapper>
            <Wrapper>
              <MessageHeading text="Profile Image" />
              <AdminImageUploadZone
                onChange={handleImageChange}
                selectedFile={profileImageFile}
                uploadedImage={editPartner?.avatar}
                onDelete={() => handleClearSelectFile('image')}
                ref={profileRef}
                name="image"
                id={id}
                accept="image/jpeg,image/png,image/jpg,image/webp"
                error={editPartnerError?.image}
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Thumbnail Image" />
              <AdminImageUploadZone
                onChange={handleImageChange}
                selectedFile={thumbnailImageFile}
                uploadedImage={editPartner?.thumbnail_image}
                onDelete={() => handleClearSelectFile('thumbnail')}
                name="thumbnail"
                id={id}
                accept="image/jpeg,image/png,image/jpg,image/webp"
                error={editPartnerError?.thumbnail}
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Region" />
              <div className="d-flex position-relative ">
                <p className="mb-3 mt-2 admin-input-title d-block position-relative">
                  Country
                </p>
              </div>
              <CountrySelect
                id="country-select"
                onChange={(e) => {
                  setCountryid(e.id);
                  handleWorld("country", e.name);
                }}
                defaultValue={
                  editPartner?.country ? { name: editPartner.country } : null
                }
                placeHolder="Select Country"
                inputClassName="bg-transparent theme-border-color theme-text-color border-0 country-input"
                containerClassName="custom-country"
              />

              <div className="d-flex position-relative ">
                <p className="mb-3 mt-2 admin-input-title d-block position-relative">
                  State
                </p>
              </div>

              <StateSelect
                id="state-select"
                key={`${countryid}-${editPartner?.state || ""}`}
                countryid={countryid}
                onChange={(e) => {
                  setstateid(e.id);
                  handleWorld("state", e.name);
                }}
                defaultValue={
                  editPartner?.state ? { name: editPartner.state } : undefined
                }
                placeHolder="Select State"
                inputClassName="bg-transparent theme-text-color border-0 country-input"
                containerClassName="custom-country"
              />

              <div className="d-flex position-relative ">
                <p className="mb-3 mt-2 admin-input-title d-block position-relative">
                  City
                </p>
              </div>

              <CitySelect
                id="city-select"
                key={`${countryid}-${stateid}-${editPartner?.city || ""}`}
                countryid={countryid}
                stateid={stateid}
                onChange={(e) => {
                  setCityid(e.id);
                  handleWorld("city", e.name);
                }}
                defaultValue={
                  editPartner?.city ? { name: editPartner.city } : undefined
                }
                placeHolder="Select City"
                inputClassName="bg-transparent theme-text-color border-0 country-input"
                containerClassName="custom-country"
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Role" />
              <MessageLabel text="Partner Role" className="mandatorySimple" />
              <AdminCustomSelect
                name="role_id"
                value={editPartner?.role_id}
                onChange={handleInput}
                options={defaultData?.partnerRoles ? [
                  {
                    value: defaultData.partnerRoles.id,
                    name: defaultData.partnerRoles.role_name
                  }
                ] : []}
                defaultOptionName="Select Role"
                ref={roleRef}
                error={editPartnerError?.role_id}
              />
            </Wrapper>


            <Wrapper className="mt-4">
              <MessageHeading text="Assigned Partners Management" />
              <div className="user-assignment-info mb-3">
                <div className="d-flex align-items-center text-muted">
                  <IoMdInformationCircle className="me-2" />
                  <small>
                    Existing child partners are listed below. You can edit their details or assign new users as partners.
                  </small>
                </div>
              </div>

              <div className="card shadow-sm mb-4">
                <div className="card-header bg-transparent">
                  <h6 className="mb-0">Assign New Partner</h6>
                </div>
                <div className="card-body">
                  <UserSelector
                    selectedUsers={selectedUsers}
                    onSelectionChange={setSelectedUsers}
                    multiple={true}
                    currentPartnerId={id}
                    placeholder="Search and select users to assign as child partners..."
                    className="partner-user-selector"
                  />
                </div>
              </div>


            </Wrapper>
          </RightWrapper>
        </FormContainer>

        <Wrapper className="mt-4">
          <div className="assigned-partners-list mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Partner List</h6>
              <span className="badge bg-primary">{selectedUsers.length} Total</span>
            </div>

            <AdminTable
              data={selectedUsers || []}
              loading={editUserLoading}
              columns={childColumns}
              viewType="list"
              page={childPage}
              limit={childLimit}
              handlePageChange={(p) => setChildPage(p)}
              handleSizePerPageChange={(e) => {
                setChildLimit(Number(e.target.value));
                setChildPage(1);
              }}
              options={{
                pageStartIndex: 1,
                paginationSize: 3,
                sizePerPage: childLimit,
              }}
              pagination={{
                totalItems: (selectedUsers || []).length,
                totalPages: Math.ceil((selectedUsers || []).length / childLimit),
                currentPage: childPage,
                itemsPerPage: childLimit,
                count_all: (selectedUsers || []).length
              }}
            />
          </div>
        </Wrapper>

        <AdminCustomButton
          saveMethod={handleValidate}
          saveText="Update Partner"
          type="submit"
          className="d-block ms-auto my-4"
        />
      </form>

      {/* Edit User Modal */}
      <Modal show={showUserModal} onHide={() => setShowUserModal(false)} centered size="xl">
        <Modal.Header closeButton className="theme-bg-color theme-text-color theme-border-color">
          <Modal.Title>Edit Partner User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="theme-bg-color theme-text-color" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {userToEdit && (
            <>
              <div className="row">
                <div className="col-12 mb-4">
                  <MessageHeading text="Personal Information" />
                  <div className="row mt-3">
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Username" className="mandatorySimple" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.username}
                        onChange={(e) => setUserToEdit({ ...userToEdit, username: e.target.value })}
                        placeHolder="Enter username"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Last Name" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.last_name || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, last_name: e.target.value })}
                        placeHolder="Enter last name"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Email" className="mandatorySimple" />
                      <AdminCustomInput
                        type="email"
                        value={userToEdit.email}
                        onChange={(e) => setUserToEdit({ ...userToEdit, email: e.target.value })}
                        placeHolder="Enter email"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Gender" />
                      <AdminCustomSelect
                        value={userToEdit.gender}
                        onChange={(e) => setUserToEdit({ ...userToEdit, gender: e.target.value })}
                        options={[
                          { name: "Male", value: "Male" },
                          { name: "Female", value: "Female" },
                          { name: "Other", value: "Other" },
                        ]}
                        defaultOptionName="Select Gender"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Country Code" />
                      <AdminCustomSelect
                        value={userToEdit.ccode}
                        onChange={(e) => setUserToEdit({ ...userToEdit, ccode: e.target.value })}
                        options={defaultData?.countryCodes?.map(c => ({ name: `${c.country_name} (${c.country_code})`, value: c.country_code })) || []}
                        defaultOptionName="Select Code"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Mobile Number" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.mobile_number || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, mobile_number: e.target.value })}
                        placeHolder="Enter mobile number"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="New Password" />
                      <AdminCustomInput
                        type="password"
                        value={userToEdit.password || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, password: e.target.value })}
                        placeHolder="Leave blank to keep current"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex justify-content-between align-items-center mt-4">
                        <MessageLabel text="Active Status" />
                        <label className="switch">
                          <input
                            checked={Number(userToEdit.status) === 1}
                            onChange={(e) => setUserToEdit({ ...userToEdit, status: e.target.checked ? 1 : 0 })}
                            type="checkbox"
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <MessageHeading text="Business Details" />
                  <div className="mt-3">
                    <MessageLabel text="Commission Percentage (%)" />
                    <AdminCustomInput
                      type="number"
                      value={userToEdit.commission_percentage || 0}
                      onChange={(e) => setUserToEdit({ ...userToEdit, commission_percentage: e.target.value })}
                      placeHolder="0"
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-4">
                  <MessageHeading text="UPI Details" />
                  <div className="mt-3">
                    <MessageLabel text="UPI ID" />
                    <AdminCustomInput
                      type="text"
                      value={userToEdit.upi_id || ""}
                      onChange={(e) => setUserToEdit({ ...userToEdit, upi_id: e.target.value })}
                      placeHolder="Enter UPI ID"
                    />
                    <div className="mt-2 text-dark">
                      <MessageLabel text="UPI Mobile" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.upi_mobile_number || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, upi_mobile_number: e.target.value })}
                        placeHolder="Enter UPI mobile"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-4">
                  <MessageHeading text="Bank Information" />
                  <div className="row mt-3">
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Bank Name" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.bank_name || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, bank_name: e.target.value })}
                        placeHolder="Enter bank name"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Branch Name" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.branch_name || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, branch_name: e.target.value })}
                        placeHolder="Enter branch name"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Account Number" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.account_number || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, account_number: e.target.value })}
                        placeHolder="Enter account number"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="IFSC Code" />
                      <AdminCustomInput
                        type="text"
                        value={userToEdit.IFSC_Code || ""}
                        onChange={(e) => setUserToEdit({ ...userToEdit, IFSC_Code: e.target.value })}
                        placeHolder="Enter IFSC code"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 mb-4">
                  <MessageHeading text="Region Details" />
                  <div className="row mt-3">
                    <div className="col-md-4 mb-3">
                      <MessageLabel text="Country" />
                      <CountrySelect
                        onChange={(e) => {
                          setModalCountryid(e.id);
                          setUserToEdit({ ...userToEdit, country: e.name, state: "", city: "" });
                        }}
                        defaultValue={userToEdit.country ? { name: userToEdit.country } : null}
                        placeHolder="Select Country"
                        inputClassName="bg-transparent theme-text-color theme-border-color custom-select-border"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <MessageLabel text="State" />
                      <StateSelect
                        countryid={modalCountryid}
                        onChange={(e) => {
                          setModalStateid(e.id);
                          setUserToEdit({ ...userToEdit, state: e.name, city: "" });
                        }}
                        defaultValue={userToEdit.state ? { name: userToEdit.state } : null}
                        placeHolder="Select State"
                        inputClassName="bg-transparent theme-text-color theme-border-color custom-select-border"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <MessageLabel text="City" />
                      <CitySelect
                        countryid={modalCountryid}
                        stateid={modalStateid}
                        onChange={(e) => {
                          setModalCityid(e.id);
                          setUserToEdit({ ...userToEdit, city: e.name });
                        }}
                        defaultValue={userToEdit.city ? { name: userToEdit.city } : null}
                        placeHolder="Select City"
                        inputClassName="bg-transparent theme-text-color theme-border-color custom-select-border"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 mt-4 border-top pt-4">
                  <MessageHeading text="Partner Visuals" />
                  <div className="row mt-3">
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Profile Image" />
                      <AdminImageUploadZone
                        onChange={(e) => setModalAvatarFile(e.target.files[0])}
                        selectedFile={modalAvatarFile}
                        uploadedImage={userToEdit.avatar}
                        onDelete={() => setModalAvatarFile(null)}
                        name="modal_avatar"
                        id={userToEdit.id || userToEdit.user_id}
                        accept="image/*"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <MessageLabel text="Thumbnail Image" />
                      <AdminImageUploadZone
                        onChange={(e) => setModalThumbnailFile(e.target.files[0])}
                        selectedFile={modalThumbnailFile}
                        uploadedImage={userToEdit.thumbnail_image}
                        onDelete={() => setModalThumbnailFile(null)}
                        name="modal_thumbnail"
                        id={userToEdit.partner_id}
                        accept="image/*"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="theme-bg-color theme-text-color theme-border-color">
          <button className="btn btn-secondary" onClick={() => setShowUserModal(false)}>
            Cancel
          </button>
          <AdminCustomButton
            saveText="Save Changes"
            saveMethod={handleSaveUser}
            loading={editUserLoading}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default EditPartner;
